import { ChemistryLitElement } from '@adornis/chemistry/chemistry-tailwind-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { baseConfig } from '@adornis/config/baseConfig.js';
import type { SidebarSectionDefinition } from '@chancenwerk/client/components/chancen-component-auto-navigation.js';
import { ChancenPermission } from '@chancenwerk/shared/permissions.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import logoCW from '../assets/logo.svg';
import logo from '../assets/logo_chancenboard_white.png';
import { BoardRoutes } from '../routes.js';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const version = require('../../../package.json').version;

const navigation: SidebarSectionDefinition[] = [
  {
    name: 'Übersicht',
    subsections: [
      {
        name: '',
        links: [
          {
            label: 'KPF-Übersicht',
            route: BoardRoutes.overview,
            icon: 'school',
            permission: ChancenPermission.board.VIEW_KPF_OVERVIEW,
          },
          {
            label: 'digitale Intensivkurse',
            route: BoardRoutes.digital,
            icon: 'language',
            permission: ChancenPermission.board.VIEW_DIGITAL_COURSES,
          },
          {
            label: 'Wochenübersicht Präsenzkurse',
            route: BoardRoutes.weekOverview,
            icon: 'calendar_month',
            permission: ChancenPermission.board.VIEW_WEEK_OVERVIEW,
          },
          {
            label: 'Team-Treffen',
            route: '/team-treffen',
            icon: 'calendar_month',
            permission: ChancenPermission.board.EDIT_TEAM_TREFFEN,
          },
          ...(baseConfig.get('DEPLOYMENT') !== 'production'
            ? [
                {
                  label: 'Tätigkeiten',
                  route: '/work-tracking',
                  icon: 'language',
                  permission: ChancenPermission.board.EDIT_WORK_TRACKING,
                },
              ]
            : []),
        ],
      },
    ],
  },
  {
    name: 'Anwesenheit',
    subsections: [
      {
        name: '',
        links: [
          {
            label: 'Erfassung',
            route: BoardRoutes.attendance,
            icon: 'calendar_month',
            permission: ChancenPermission.board.VIEW_ATTENDANCE,
          },
          {
            label: 'Export',
            route: BoardRoutes.attendanceExport,
            icon: 'calendar_month',
            permission: ChancenPermission.board.EXPORT_ATTENDANCE,
          },
          {
            label: 'Export-Historie',
            route: BoardRoutes.attendanceExportHistory,
            icon: 'calendar_month',
            permission: ChancenPermission.board.EXPORT_ATTENDANCE_HISTORY,
          },
        ],
      },
    ],
  },
];

/**
 * @customElement board-component-sidebar
 */
@customElement('board-component-sidebar')
export class BoardComponentSidebar extends ChemistryLitElement {
  override styles() {
    return [...super.styles(), { ':host': { zIndex: '9999' } }];
  }

  override render() {
    return html`<cr-sidebar
      ${css({ zIndex: '9999' })}
      .version=${version}
      .logoRouteTo=${window.location.href}
      .imageRef=${logoCW}
    >
      <cr-flex slot="logo" padding="md" ${css({ cursor: 'pointer' })}>
        <cr-image disabled loading="eager" ${css({ width: '225px' })} is-url .value=${logo} mode="width"></cr-image>
      </cr-flex>

      <chancen-component-auto-navigation .sections=${navigation} mode="All"> </chancen-component-auto-navigation>
    </cr-sidebar>`;
  }
}
